// extracted by mini-css-extract-plugin
module.exports = {"container":"Languages_container__ZdEtL","wrapper":"Languages_wrapper__hSD65","current":"Languages_current__tATDV"};